const hourToPeriod = hour => (hour >= 12 ? 'pm' : 'am');

const militaryToStandardHour = hour => (hour > 12 ? hour - 12 : hour);

export const supportedTimeZones = [
  { value: 'HST', label: 'Hawaii Time', offset: -2 },
  { value: 'AST', label: 'Alaska Time', offset: -1 },
  { value: 'PST', label: 'Pacific Time', offset: 0 },
  { value: 'MST', label: 'Mountain Time', offset: 1 },
  { value: 'CST', label: 'Central Time', offset: 2 },
  { value: 'EST', label: 'Eastern Time', offset: 3 }
];

export const timezoneOffsetMap = supportedTimeZones.reduce((acc, timezone) => {
  acc[timezone.value] = timezone.offset;
  return acc;
}, {});

export const getTimezoneOffset = timezone => timezoneOffsetMap[timezone] || 0;

export const formatTimeToUserTimezone = (time, timezone = getDefaultTimezone()) => {
  const [hour, min] = time.split(':');
  const offsetHour = parseInt(hour, 10) + getTimezoneOffset(timezone);
  const standardTimeHour = militaryToStandardHour(offsetHour);
  return `${standardTimeHour}:${min}${hourToPeriod(offsetHour)}`;
};

export const getDefaultTimezone = () => {
  try {
    const timezone = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    return timezoneOffsetMap.hasOwnProperty(timezone) ? timezone : 'PST';
  } catch (e) {
    return 'PST';
  }
};

export const getDefaultTimeSlots = () => {
  const defaultTimeSlots = [
    { value: '15:00' }, { value: '15:10' }, { value: '15:20' }, { value: '15:30' }, { value: '15:40' }, { value: '15:50' },
    { value: '16:00' }, { value: '16:10' }, { value: '16:20' }, { value: '16:30' }, { value: '16:40' }, { value: '16:50' },
    { value: '17:00' }, { value: '17:10' }, { value: '17:20' }, { value: '17:30' }, { value: '17:40' }, { value: '17:50' },
    { value: '18:00' }, { value: '18:10' }, { value: '18:20' }, { value: '18:30' }, { value: '18:40' }, { value: '18:50' }
  ];

  return transformSlotsForTimezone({ slots: defaultTimeSlots });
};

export const transformSlotsForTimezone = ({ slots = [], timezone = getDefaultTimezone() }) =>
  slots.map(slot => {
    const [hour, min] = slot.value.split(':');
    const offsetHour = parseInt(hour, 10) + getTimezoneOffset(timezone);
    const standardTimeHour = militaryToStandardHour(offsetHour);
    return { ...slot, label: `${standardTimeHour}:${min}${hourToPeriod(offsetHour)}` };
  })
;
